(function ($) {
    $(function () {
        $('.close-year').click(closeYear);
        $('.toggle-year').click(toggleYear);


        function closeYear(e) {
            var link = e.target.parentElement.parentElement;
            var year = link.dataset.year;
            var $toggle = $('.toggle-year[data-year="' + year + '"]');
            var $notes = $('.notes[data-year="' + year + '"]');
            $toggle.removeClass('active');
            $notes.slideUp();
        }

        function toggleYear(e) {
            var link = e.target;
            var year = link.dataset.year;
            var $notes = $('.notes[data-year="' + year + '"]');
            console.log("toggle year " + year);
            if (link.classList.contains('active')) {
                link.classList.remove('active');
                $notes.slideUp();
            } else {
                link.classList.add('active');
                $notes.slideDown();
            }
        }
    });
})($JQ);